import { useState, useEffect } from "react";

// Helper function to get wishlist from localStorage
const getWishlistFromStorage = () => {
  if (typeof window !== 'undefined') {
    const storedWishlist = localStorage.getItem('wishlist');
    return storedWishlist ? JSON.parse(storedWishlist) : [];
  }
  return [];
};

// Custom hook to manage the wishlist state and operations
export const useWishlist = () => {
  // Initialize state with localStorage data
  const [wishlist, setWishlist] = useState(() => getWishlistFromStorage());

  // Sync state with localStorage whenever wishlist changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
    }
  }, [wishlist]);

  /* 1- Add an item to the wishlist */
  const addToWishlist = (item) => {
    const isItemExist = wishlist.some((wishlistItem) => wishlistItem.id === item.id);
    
    if (!isItemExist) {
      const options = { month: 'long', day: 'numeric', year: 'numeric' };
      const currentDate = new Date().toLocaleDateString('en-US', options);
      const newItem = { ...item, dateAdded: currentDate };
      
      setWishlist(prev => [...prev, newItem]);
    }
  };

  /* 2- Delete item from the wishlist */
  const removeFromWishlist = (item) => {
    setWishlist(prev => prev.filter(wishlistItem => wishlistItem.id !== item.id));
  };

  // Return the wishlist state and operations
  return { wishlist, addToWishlist, removeFromWishlist };
};